import { UserStatusLevel } from 'shared/src/api/types'
import { createUseStyles } from 'react-jss'

import verifiedBadge from '../../assets/verified-badge.svg'
import spotlightBadge from '../../assets/spotlight-badge.svg'
import editorBadge from '../../assets/editor-badge.svg'

const useStyles = createUseStyles({
  verifiedBadge: {
    height: 16,
    paddingLeft: 4,
  },
  spotlightBadge: {
    paddingLeft: 4,
    height: 16,
    filter: 'drop-shadow(0px 0px 4px #FFFFFF)',
  },
  editorBadge: {
    paddingLeft: 4,
    height: 16,
    filter: 'drop-shadow(0px 0px 4px #F8C78F)',
  },
})

export default function UserBadge({
  statusLevel,
  style,
}: {
  statusLevel?: UserStatusLevel
  style?: React.CSSProperties
}) {
  if (!statusLevel || statusLevel === UserStatusLevel.Regular) {
    return <></>
  }
  const classes = useStyles()
  let icon
  let className
  if (statusLevel === UserStatusLevel.Verified) {
    icon = verifiedBadge
    className = classes.verifiedBadge
  } else if (statusLevel === UserStatusLevel.Spotlight) {
    icon = spotlightBadge
    className = classes.spotlightBadge
  } else if (statusLevel === UserStatusLevel.Editor) {
    icon = editorBadge
    className = classes.editorBadge
  }

  return (
    <img style={style} src={icon} alt={statusLevel} className={className} />
  )
}
